/* eslint-disable */

export enum SiteMode {
	Unknown = 0,
	Private = 1,
	Company = 2,
	
}
